/* eslint-disable react/destructuring-assignment */
import { Tooltip, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import React from "react";
import { buildEmbedSnippet } from "./embedSnippet";

const CodeView = props => {
  const script = buildEmbedSnippet(props.widgetId);
  return (
    <div className="p-2 gap-2 w-full flex-row-centered items-center">
      <code className="p-2 inline-block w-full overflow-x-auto bg-slate-100 rounded">{script}</code>
      <Tooltip title="Copy to clipboard">
        <CopyOutlined
          className="cursor-pointer"
          onClick={() => {
            navigator.clipboard
              .writeText(script)
              .then(() => {
                props && props.onCopy && props.onCopy();
                message.success("Script copied successfully");
              })
              .catch(err => message.error(err.message));
          }}
        />
      </Tooltip>
    </div>
  );
};

export default CodeView;
